import { render, staticRenderFns } from "./TermModal.vue?vue&type=template&id=216fd6ba&scoped=true"
import script from "./TermModal.vue?vue&type=script&lang=js"
export * from "./TermModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216fd6ba",
  null
  
)

export default component.exports